import React, {useEffect, useState} from "react"
import {Button, CardTitle, Col, Form, Input, Label, Progress, Row, Table} from "reactstrap"
import PropTypes from "prop-types"
import {ToastContainer, toast} from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import {Slide} from "react-toastify"
import API from "../../api"
import Select from "react-select";

const AddAffectation = props => {
    var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
    var annee_id = userAuthScolarite.user.annee_id
    const [groupe, setGroupe] = useState([])
    const [selectGroupe, setSelectGroupe] = useState("")
    const [affiche, setAffiche] = useState(false)
    const [enseignant, setEnseignant] = useState([])
    const [selectEnseignant, setSelectEnseignant] = useState("")
    const [cycle, setCycle] = useState([
        {value: 1, label: "Licence"},
        {value: 2, label: "Mastère de Recherche"},
        {value: 3, label: "Mastère Professionnel"}
    ])
    const [selectCycle, setSelectCycle] = useState("")
    const [specilaite, setSpecilaite] = useState([])
    const [selectSpecilaite, setSelectSpecilaite] = useState("")
    const [etudiant, setEtudiant] = useState([])
    const [selectEtudiant, setSelectEtudiant] = useState("")
    const [array, setArray] = useState([
        {enseignant_id: "", group_id: "", etudiant_id: []},
    ])
    const [annee, setAnnee] = useState([])
    const [selectAnnee, setSelectAnnee] = useState("")
    const [enseignantChef, setEnseignantChef] = useState([])
    const [selectEnseignantChef, setSelectEnseignantChef] = useState("")
    const [departement, setDepartement] = useState([])
    const [selectDepartement, setSelectDepartement] = useState("")
    const getSpecilaite = async (e) => {
        setSelectCycle(e)
        setSelectSpecilaite("")
        setSelectEnseignant("")
        setArray([{enseignant_id: "", group_id: "", etudiant_id: []}])
        const res = await API.post("specialite/select_by_cycle_departement_id", {
            cycle_id: e.value,
            departement_id: selectDepartement.value,annee_id
        }).then(res => {
            setSpecilaite(res.data.Specialite)
        })
        const resEns = await API.post("enseignant/list_enseignant_departement", {
            departement_id: selectDepartement.value,annee_id
        }).then(resEns => {
            setEnseignant(resEns.data.Enseignant)
        })
    }
    const getCycle = async (e) => {
        setSelectAnnee(e)
        setSelectCycle("")
        setSelectSpecilaite("")
        setSelectEnseignant("")
        setSelectDepartement("")
        setArray([{enseignant_id: "", group_id: "", etudiant_id: []}])
    }
    const getList = async (e) => {
        setSelectSpecilaite(e)
        setArray([{enseignant_id: "", group_id: "", etudiant_id: []}])
    }
    const display = () => {
        if (!selectCycle || !selectSpecilaite || array.length === 0 || array.some(item => item.etudiant_id.length === 0)) {
            setAffiche(false);
            toast.error("⛔ Tous les champs sont obligatoires, y compris les étudiants !", {
                containerId: "A",
            });
        }
        else {
            setAffiche(true)
            API.post("etudiant/store_encadrement", {
                cycle_id: selectCycle.value,
                specialite_id: selectSpecilaite.value,
                listAffect:array,
                annee_id: annee_id,
                departement_id: selectDepartement.value,
                annee_etudiant:selectAnnee.value
            }).then(res => {
               props.setSection(1)
            })
        }
    }
    useEffect(async () => {
        const res = await API.get("annee/select").then(res => {
            setAnnee(res.data.Annee[0].ListAnnee)
            setSelectAnnee(res.data.Annee[0].CurrentAnnee[0])
        })
        const resDep = await API.get("departement/select").then(resDep => {
            setDepartement(resDep.data.Departement)
        })
    }, [])
    const addLigne = () => {
        let element = {
            enseignant_id: "",
            group_id: "",
            etudiant_id: "",
        }
        setArray([...array, element])
    }
    const addEnseignant = async (event, index) => {
        setSelectEnseignant(event);
        setArray(prevArray =>
            prevArray.map((el, id) =>
                id === index
                    ? {
                        ...el,
                        enseignant_id: event,
                        group_id: "",
                        etudiant_id: []
                    }
                    : el
            )
        );
        try {
            const res = await API.post("group/get_group_by_cycle_specialite", {
                specialite_id: selectSpecilaite.value,
                departement_id: selectDepartement.value,
                cycle_id: selectCycle.value,
                annee_id: selectAnnee.value,
            });
            setGroupe(res.data.Group);
        } catch (error) {
            console.error("Erreur API :", error);
        }
    };


    const addGroup = (event, index) => {
        setSelectGroupe(event.value)
        setArray(prevArray =>
            prevArray.map((el, id) =>
                id === index
                    ? {
                        ...el,
                        group_id: event,
                        etudiant_id: [],
                    }
                    : el
            )
        );
        const res =  API.post("group/get_etudiant_by_cycle_specialite", {
            specialite_id: selectSpecilaite.value,
            departement_id: selectDepartement.value,
            cycle_id: selectCycle.value,
            annee_id: selectAnnee.value,
            group_id: event.value,
        }).then(res => {
            setEtudiant(res.data.Etudiant);
        });
    }
    const addEtudiant = (event, index) => {
        setSelectEtudiant(event.value)
        setArray(
            array.map((el, id) =>
                id === index ? Object.assign(el, {etudiant_id: event}) : el
            )
        )
    }
    return (
        <React.Fragment>
            <Row>
                <Form>
                    <Row>
                        <Col lg="3">
                            <div className="mb-3">
                                <Label for="basicpill-firstname-input1">Année</Label>
                                <Select
                                    options={annee}
                                    isSearchable={true}
                                    value={selectAnnee}
                                    onChange={e => getCycle(e)}
                                />
                            </div>
                        </Col>
                        <Col lg="3">
                            <div className="mb-3">
                                <Label for="basicpill-firstname-input1">Département</Label>
                                <Select
                                  options={departement}
                                  isSearchable={true}
                                  value={selectDepartement}
                                  onChange={e => setSelectDepartement(e)}
                                />
                            </div>
                        </Col>
                        <Col lg="3">
                            <div className="mb-3">
                                <Label for="basicpill-firstname-input1">Cycle</Label>
                                <Select
                                    options={cycle}
                                    isSearchable={true}
                                    value={selectCycle}
                                    onChange={e => getSpecilaite(e)}
                                />
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="mb-3">
                                <Label for="basicpill-firstname-input1">
                                    Specialite
                                </Label>
                                <Select
                                    options={specilaite}
                                    isSearchable={true}
                                    onChange={e => getList(e)}
                                    value={selectSpecilaite}
                                />
                            </div>
                        </Col>
                    </Row>
                    <CardTitle style={{color: "#556ee6"}} className="h4 mb-2 mt-2">
                        Affecter des étudiants à l’enseignant :
                    </CardTitle>
                    <table className="table table-bordered mt-4">
                        <thead>
                        <tr>
                            <th style={{textAlign: "center"}} scope="col">Enseignant</th>
                            <th style={{textAlign: "center"}} scope="col">Groupe</th>
                            <th style={{textAlign: "center"}} scope="col">Etudiant</th>
                            <th style={{textAlign: "center"}} scope="col">
                                <i
                                    style={{color: "#a0ceb8", cursor: "pointer"}}
                                    className="fas fa-plus"
                                    onClick={addLigne}
                                />
                            </th>
                        </tr>
                        </thead>
                        {array.map((el, index) => (
                            <tbody key={index}>
                            <tr>
                                <td className="col-md-2">
                                    <Select
                                        options={enseignant}
                                        isSearchable={true}
                                        value={el.enseignant_id}
                                        onChange={e => addEnseignant(e, index)}
                                    />
                                </td>
                                <td className="col-md-2">
                                    <Select
                                        options={groupe}
                                        isSearchable={true}
                                        value={el.group_id}
                                        onChange={e => addGroup(e, index)}
                                    />
                                </td>
                                <td className="col-md-2">
                                    <Select
                                        options={etudiant}
                                        isSearchable={true}
                                        value={el.etudiant_id}
                                        isMulti={true}
                                        onChange={e => addEtudiant(e, index)}
                                    />
                                </td>
                                <td className="col-md-1" style={{textAlign: "center"}}>
                                    <i
                                        style={{color: "#cc0000", cursor: "pointer"}}
                                        className="mdi mdi-delete font-size-18"
                                        id="deletetooltip"
                                        onClick={() => toggle(index)}
                                    />
                                </td>
                            </tr>
                            </tbody>
                        ))}
                    </table>

                    <div style={{display: "flex", justifyContent: "center"}}>


                        <Col lg="6">
                            <div className="text-center mt-4">
                                <button
                                    type="button"
                                    className="btn btn-primary "
                                    onClick={display}>
                                    Enregistrer
                                </button>
                            </div>
                        </Col>
                    </div>

                </Form>

            </Row>
            <ToastContainer
                transition={Slide}
                enableMultiContainer
                containerId={"A"}
                position={toast.POSITION.TOP_RIGHT}
                autoClose={2500}
            />
        </React.Fragment>
    )
}

export default AddAffectation
AddAffectation.propTypes = {
    history: PropTypes.object,
    back: PropTypes.object,
    setSection: PropTypes.object,
    t: PropTypes.any,
}
